<template>
  <v-container class="mini-widget-table" :class="{ minimal }">
    <v-row class="mini-widget-table-row">
      <v-col cols="1" class="mini-widget-table-col id">#{{ value.id }}</v-col>
      <v-col cols="2" class="mini-widget-table-col datetime">
        <div style="max-width: 79px;">{{ formatDate(value.datetime) }}</div>
      </v-col>
      <v-col cols="2" class="mini-widget-table-col customer">
        <CustomerCard
          :value="value.customer"
          :noneRef="value.ref"
          hideId
          hideCpf
          mini
          noPadding
        />
      </v-col>
      <v-col cols="3" class="mini-widget-table-col order" v-if="!minimal">
        <!-- Resumo Pedido -->
      </v-col>
      <v-col cols="3" class="mini-widget-table-col status">
        <span
          class="status"
          :class="`${getStatus(value.status).color}--text`"
        >
          <v-icon
            v-text="getStatus(value.status).icon"
            :color="getStatus(value.status).color"
            class="mr-1"
            small
          />
          {{ getStatus(value.status).title }}
        </span><br />
        <span
          class="status"
          :class="`${getPaid(value).color}--text`"
        >
          <v-icon
            v-text="getPaid(value).icon"
            :color="getPaid(value).color"
            class="mr-1"
            small
          />
          {{ getPaid(value).title }}
        </span>
      </v-col>
      <v-col cols="1" class="mini-widget-table-col total">
        <span class="text-body-1 font-weight-black">
          {{ formatCurrency(value.total) }}
        </span>
        <span
          v-if="value.total_paid > 0"
          class="light-green--text accent-4--text total-paid"
        >
          {{ formatCurrency(value.total_paid) }}
        </span>
        <span
          v-if="value.total_left > 0"
          class="orange--text total-left"
        >
          {{ formatCurrency(value.total_left) }}
        </span>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import CustomerCard from '@/components/customers/templates/OrderCard'

import appdata from '@/mixins/appdata'
import utils from '@/mixins/utils'
import orders from '@/components/orders/mixins/index'

export default {
  components: { CustomerCard },
  mixins: [ appdata, utils, orders ],
  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    },
    minimal: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss">
#app .mini-widget-table {
  padding: 5px 0px !important;
  margin: 0px !important;
  &-row {
    padding: 0px !important;
    margin: 0px !important;
    line-break: auto;
    white-space: initial;
    line-height: 17px;
    * {
      font-size: 0.95em !important;
    }
  }
  &-col {
    padding: 5px !important;
    &.id {
      flex: 0 0 12%;
      max-width: 12%;
    }
    &.datetime {
      flex: 0 0 15%;
      max-width: 15%;
    }
    &.customer {
      flex: 0 0 21%;
      max-width: 21%;
    }
    &.order {
      flex: 0 0 23%;
      max-width: 23%;
    }
    &.status {
      flex: 0 0 19%;
      max-width: 19%;
    }
    &.total {
      flex: 0 0 10%;
      max-width: 10%;
      span {
        float: right;
        line-height: 14px;
        &.total-paid {
          font-size: 0.84em !important;
        }
        &.total-left {
          font-size: 0.84em !important;
        }
      }
    }
  }
  &.minimal {
    .mini-widget-table-col {
      &.datetime {
        flex: 0 0 17% !important;
        max-width: 17% !important;
      }
      &.customer {
        flex: 0 0 28.6% !important;
        max-width: 28.6% !important;
      }
      &.status {
        flex: 0 0 24.6% !important;
        max-width: 24.6% !important;
      }
      &.total {
        flex: 0 0 17.6% !important;
        max-width: 17.6% !important;
      }
    }
  }
}
</style>